// extracted by mini-css-extract-plugin
export default {"mainContainer":"NFCr2","container":"XgLGG","image":"IAZCU","color":"d6+f0","waitingScreenColor":"crJms"};